export default __webpack_public_path__ + "static/media/logo.b64ead79.svg";